"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Menu = _interopRequireDefault(require("./Menu"));
var _ApplicationContext = require("./ApplicationContext");
var _SecurityContextHolder = require("./SecurityContextHolder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // eslint-disable-next-line import/no-cycle
// Have to fix the dependency cycle! For now it does not seem to affect anything

class SecurityContext {
  constructor() {
    _defineProperty(this, "tokenId", null);
    _defineProperty(this, "originalToken", null);
    _defineProperty(this, "refreshToken", null);
    _defineProperty(this, "expirationDate", null);
    _defineProperty(this, "contextId", null);
    _defineProperty(this, "uid", null);
    _defineProperty(this, "accountId", null);
    _defineProperty(this, "userId", null);
    _defineProperty(this, "loginId", null);
    _defineProperty(this, "clientId", null);
    _defineProperty(this, "siteAreaId", null);
    _defineProperty(this, "firstName", null);
    _defineProperty(this, "lastName", null);
    _defineProperty(this, "emailAddress", null);
    _defineProperty(this, "privileges", null);
    _defineProperty(this, "menu", new _Menu.default());
    _defineProperty(this, "subSiteId", null);
    _defineProperty(this, "menuMap", {});
    _defineProperty(this, "additionalData", null);
  }
  static from(json) {
    const obj = Object.assign(new SecurityContext(), json);
    if (json.menu) {
      obj.setMenu(json.menu);
    }
    return obj;
  }
  doRefresh(refreshData) {
    this.tokenId = refreshData.profile.accessToken;
    this.setRefreshToken(refreshData);
    _SecurityContextHolder.SecurityContextHolder.setCurrentContext(this);
  }
  setRefreshToken(tokenData) {
    this.refreshToken = tokenData.refreshToken;
    const expirationDate = new Date();
    expirationDate.setSeconds(expirationDate.getSeconds() + tokenData.expiresIn);
    this.expirationDate = expirationDate;
  }
  setAdditionalData(additionalData) {
    this.additionalData = additionalData;
  }
  setMenu(json) {
    this.menu = _Menu.default.from(json);
    if (_ApplicationContext.ApplicationContext.isMultiSite() && (this.subSiteId == null || this.subSiteId === -1)) {
      const topMenus = this.menu.getChildren('Main-Menu-Links');
      const filtered = topMenus.filter(site => typeof site.visible !== 'undefined' && site.visible);
      if (filtered.length > 0) {
        this.subSiteId = filtered[0].id;
      }
      this.loadMenuMap(topMenus, -1);
    }
  }
  loadMenuMap(menuItems, topLevel) {
    for (let i = 0; i < menuItems.length; i++) {
      const menuItem = menuItems[i];
      let parentId = topLevel;
      if (topLevel === -1) {
        parentId = menuItem.id;
      }
      const data = {
        menuItem,
        parentItem: parentId
      };
      this.menuMap[`m${menuItem.id}`] = data;
      this.loadMenuMap(menuItem.children, parentId);
    }
  }
  getSelectedSubSite() {
    let selected = null;
    if (_ApplicationContext.ApplicationContext.isMultiSite() && this.subSiteId !== -1) {
      const menuData = this.menuMap[`m${this.subSiteId}`];
      if (typeof menuData !== 'undefined' && menuData != null) {
        selected = menuData.menuItem;
      }
    }
    return selected;
  }
  verifySubSite(props, menuItem) {
    if (!_ApplicationContext.ApplicationContext.isMultiSite()) {
      return;
    }
    const menuData = this.menuMap[`m${menuItem.id}`];
    if (typeof menuData === 'undefined' || menuData == null) {
      return;
    }
    if (this.subSiteId !== menuData.parentItem) {
      this.subSiteId = menuData.parentItem;
      _SecurityContextHolder.SecurityContextHolder.setCurrentContext(this);
      props.history.push(menuItem.path);
    }
  }
  getMainMenuLinks() {
    const selected = this.getSelectedSubSite();
    if (selected != null) {
      return selected.children;
    }
    return this.menu.getChildren('Main-Menu-Links');
  }
}
exports.default = SecurityContext;
//# sourceMappingURL=SecurityContext.js.map